module.exports = __webpack_public_path__ + "static/img/text.d689f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/text.png
// module id = cCQf
// module chunks = 1